import type { BoxProgramDefaultSettingsFormFields } from "@/modules/boxProgrammation/formik/boxProgramFormTypes"
import type {
  BoxProgramSlotDefaultSettingsDto,
  BoxProgramSlotDefaultSettingsInputDto,
} from "@/modules/boxProgrammation/gateway/boxProgramSlotDefaultSettingsDto"
import { type BoxSlotParticipation } from "@/modules/boxSlot/boxSlotTypes"
import { UserEntity } from "@/modules/profile/userProfile/userEntity"

export type BoxProgramSlotDefaultSettingsState = Omit<BoxProgramSlotDefaultSettingsEntity, "toFormik">

export class BoxProgramSlotDefaultSettingsEntity {
  duration: number | null
  participantLimit: number | null
  location: string | null
  participation: BoxSlotParticipation | null
  allowMultiBooking: boolean
  assignedStaffMembers: UserEntity[]
  dropinsAccepted: boolean
  trialsAccepted: boolean

  private constructor(state: BoxProgramSlotDefaultSettingsState) {
    this.duration = state.duration
    this.participantLimit = state.participantLimit
    this.location = state.location
    this.participation = state.participation
    this.allowMultiBooking = state.allowMultiBooking
    this.assignedStaffMembers = state.assignedStaffMembers
    this.dropinsAccepted = state.dropinsAccepted
    this.trialsAccepted = state.trialsAccepted
  }

  static fromDto(dto: BoxProgramSlotDefaultSettingsDto): BoxProgramSlotDefaultSettingsEntity {
    return new BoxProgramSlotDefaultSettingsEntity({
      duration: dto.duration,
      participantLimit: dto.participantLimit,
      location: dto.location,
      participation: dto.participation,
      allowMultiBooking: dto.allowMultiBooking,
      assignedStaffMembers: dto.assignedStaffMembers?.map((staff) => UserEntity.fromDto(staff)) ?? [],
      dropinsAccepted: dto.dropinsAccepted,
      trialsAccepted: dto.trialsAccepted,
    })
  }

  toFormik(): BoxProgramDefaultSettingsFormFields {
    return {
      duration: this.duration ?? 60,
      participantLimit: this.participantLimit ?? null,
      location: this.location ?? null,
      limitStart: this.participation?.limitStart ?? undefined,
      limitEnd: this.participation?.limitEnd ?? undefined,
      limitCancel: this.participation?.limitCancel ?? undefined,
      allowMultiBooking: this.allowMultiBooking,
      assignedStaffMembers: this.assignedStaffMembers,
      dropinsAccepted: this.dropinsAccepted,
      trialsAccepted: this.trialsAccepted,
    }
  }

  static fromFormikToCreateOrUpdateInputDto(
    formik: BoxProgramDefaultSettingsFormFields,
  ): BoxProgramSlotDefaultSettingsInputDto {
    return {
      duration: formik.duration,
      participantLimit: formik.participantLimit,
      location: formik.location,
      participation: {
        limitStart: formik.limitStart ?? null,
        limitEnd: formik.limitEnd ?? null,
        limitCancel: formik.limitCancel ?? null,
      },
      allowMultiBooking: formik.allowMultiBooking,
      assignedStaffMembers: formik.assignedStaffMembers.map((staff) => staff.id),
      dropinsAccepted: formik.dropinsAccepted,
      trialsAccepted: formik.trialsAccepted,
    }
  }
}
